import {
    CategoryMetadata,
    SelectedCategory,
} from '@/features/pos/components/ProductCatalog/parts/CategoryBar/types'

export const getSelectedCategoryWithMetadata = (
    selectedCategory: SelectedCategory,
    metadata: CategoryMetadata
) => ({
    id: selectedCategory.id,
    subcategoryId: selectedCategory.subcategoryId,
    hasSubcategories: metadata.hasSubcategories,
    index: metadata.index,
})
